"use strict";
/**
 * @name Button
 *
 * @description
 *  A common button component that will render the appropriate styles for a button or link.  See the teamsnap patterns
 *  library for more information https://teamsnap-ui-patterns.netlify.com/patterns/components/button.html
 *
 * @example
 *  <Button
 *    handleClick={ () => console.warn('Clicky Clicky') }
 *    color='primary'
 *    size='small'
 *    isDisabled
 *    mods='u-spaceTopMd'>
 *    Click Me
 *  </Button>
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var Icon_1 = require("../Icon");
var helpers_1 = require("../../utils/helpers");
var types_1 = require("../../types");
var ScreenReader_1 = require("../ScreenReader");
var propTypes = {
    type: PropTypes.oneOf(['button', 'submit', 'link', 'text']),
    children: PropTypes.node,
    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    isActive: PropTypes.bool,
    color: PropTypes.string,
    size: types_1.Size.PropType,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    testId: PropTypes.string,
    otherProps: PropTypes.object,
};
var Button = function (_a) {
    var className = _a.className, color = _a.color, size = _a.size, isActive = _a.isActive, mods = _a.mods, children = _a.children, icon = _a.icon, iconPosition = _a.iconPosition, type = _a.type, isDisabled = _a.isDisabled, onClick = _a.onClick, style = _a.style, testId = _a.testId, otherProps = _a.otherProps;
    var cname = (0, helpers_1.getClassName)(className, color && "Button--" + color, size && "Button--" + size, isActive && 'is-active', type === 'link' && 'Button--text', type === 'text' && 'Button--text', mods);
    var modifier = null;
    var hasVisibleChildren = children != null &&
        (Array.isArray(children) ||
            children.type !== ScreenReader_1.ScreenReader);
    if (iconPosition === 'left' && hasVisibleChildren)
        modifier = 'u-spaceRightXs';
    if (iconPosition === 'right' && hasVisibleChildren)
        modifier = 'u-spaceLeftXs';
    var maybeIcon = icon ? React.createElement(Icon_1.Icon, { name: icon, mods: modifier }) : null;
    return (React.createElement("button", __assign({ type: type === 'submit' ? 'submit' : 'button', className: cname, style: style, onClick: onClick, disabled: isDisabled, "data-testid": testId }, otherProps),
        React.createElement("span", null,
            iconPosition === 'left' && maybeIcon,
            children,
            iconPosition === 'right' && maybeIcon)));
};
Button.propTypes = propTypes;
Button.defaultProps = {
    type: 'button',
    children: null,
    icon: null,
    iconPosition: 'left',
    onClick: null,
    isDisabled: false,
    isActive: false,
    color: null,
    size: null,
    className: 'Button',
    mods: null,
    style: {},
    testId: null,
    otherProps: {},
};
exports.default = Button;
